<script lang="ts">

    import { fade } from 'svelte/transition';

</script>
<style lang="scss">
    
    .modal {
        position: fixed;
        z-index: var(--zIndex, 10);
        top: 0;
        left: 0;
        width: 100vw;
        height: var(--vh, 100vh);
        background-color: #fff;
    }

</style>

<div class="modal" transition:fade>
    <slot></slot>
</div>
